import React from "react";
import { HelpCircle } from "lucide-react";
import { useLang } from "@/context/LangContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const Faq = () => {
  const { t } = useLang();
  const f = t.faq;
  return (
    <section
      id="faq"
      className="py-24 md:py-32 bg-green-50/30"
      data-testid="faq-section"
      aria-label={f.title}
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-semibold text-green-700">
            <HelpCircle className="h-3.5 w-3.5" /> {f.eyebrow}
          </span>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">
            {f.title}
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
          {f.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-slate-100 bg-white rounded-2xl mb-3 px-5 data-[state=open]:border-green-200 data-[state=open]:shadow-sm"
            >
              <AccordionTrigger
                className="text-left font-display font-semibold text-base text-slate-900 hover:no-underline py-5"
                data-testid={`faq-trigger-${i}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                className="text-slate-600 text-base leading-relaxed pb-5"
                data-testid={`faq-content-${i}`}
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;
